export const DISCLAIMER_MESSAGES = {
  appointmentDisclaimer:
    'Please confirm the provider’s acceptance of your insurance network and plan when making an appointment.',
  longDisclaimer: [
    'The purpose of this portal is to provide you information about top performing in-network physicians for medical needs that you specify. This information is provided for informational purposes only and does not constitute providing medical advice, medical or professional services. Any information provided should not be used for diagnosing or treating a health problem or disease.',
    'The physicians that may be listed in your search results are not guaranteed to be in-network for your medical plan or insurance coverage. Prior to making an appointment, and to avoid unnecessary charges or rejected claims, be sure to confirm participation of the physician with your medical plan or insurer.',
    'Services provided by physicians that may be listed in your search results are not guaranteed to be covered by your medical plan or insurance coverage. Prior to making an appointment, and to avoid unnecessary charges or rejected claims, be sure to confirm coverage with your insurer or medical plan administrator.',
  ],
  insuranceDisclaimer:
    'Please contact the provider’s office directly to confirm acceptance of your insurance network and plan.',
}

export const SafetyDisclaimer = (): JSX.Element => (
  <>
    If you think you may be having a medical emergency, please call{' '}
    <span style={{ fontWeight: 600 }}>9-1-1</span> or go to the nearest
    emergency room immediately. For immediate help with a psychological crisis,
    including suicidal thoughts, please call{' '}
    <span style={{ fontWeight: 600 }}>9-8-8</span>.
  </>
)
